<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<template>
<div>
  <!-- <img src="/img/buyleft.jpg" :style="!dk?'width: 29%;position: fixed;left:0;top:0':''"/> -->
  <div :style="!dk?'width: 42% !important;margin-left: 29%;':''">
    <div class="half-angle bg-white margin padding">
   <div class="text-center text-black text-xl"> 剩余支付时间</div>
   <!-- <div class="text-center text-orange text-bold text-xl ">10:00:00</div> -->
   <div class="text-center text-red text-bold text-xl " style="margin-top: 10px;">{{countdown}}</div>
</div>
<div class="half-angle bg-white margin padding" style="text-align: left;">
    <div class="flex" style=" display: flex;align-items:center;">
      <div class="text-black text-bold text-xl " ><span class="text-bold text-red">*</span > 姓<div style="width: 21px;display: inline-block;"></div>名</div>
      <input type="text" v-model="userName" class="text-black text-xl margin-left-xl input1" style="margin-left: 3px;"  placeholder="请 输 入 姓 名"/>
   </div>
   <!-- <div class="margin-top-xs text-xl2 b-b" style="color: #ec3030;margin-left: 12px;padding-bottom: 10px;letter-spacing: 1px;" >用于联系您时的称呼</div> -->
   <div class="flex" style="margin-top: 10px;display: flex;align-items:center;">
      <div class="text-black text-bold text-xl " style="letter-spacing: 1px;"><span class="text-bold text-red">*</span> 手机号</div>
      <input v-model="userPhone" type="text" class="text-black text-xl margin-left-xl input1"  placeholder="请输入手机号"/>
   </div>
   <!-- <div class="margin-top-xs text-xl2" style="color: #ec3030;margin-left: 12px;letter-spacing: 1px;" >用于完成购买使用</div> -->
</div>
<!-- <div v-if="info.reservationType==1" class="half-angle bg-white margin padding  " style="text-align: left;">
   <div class="cu-form-group1 margin-top-xs text-xl" >
      <div class="text-black text-bold text-xl "><span class="text-bold text-red">*</span > 校区选择</div>
      <div @click="shopChooseShop()">{{ checkIndex==null?'请选择服务校区':shopList[checkIndex].shopName }} ></div>
   </div>
</div> -->
<div v-if="info.applInfo" class="half-angle bg-white margin padding  " style="text-align: left;">
   <div class="text-black text-bold padding-bottom-smtext-cut text-xl "><span class="text-bold text-red">*</span> 校区选择</div>
   <div class="cu-form-group margin-top-xs text-xl" >
    <div class="title" @click="shopChooseShop()">{{ checkIndex==null?'请选择服务校区':shopList[checkIndex].shopName }} ></div>
      <!-- <div class="title">{{info.applInfo||''}}</div> -->
   </div>
</div>
<div v-if="info.applInfo" class="half-angle bg-white margin padding  " style="text-align: left;">
   <div class="text-black text-bold padding-bottom-smtext-cut text-xl "><span class="text-bold text-red">*</span> 报名须知</div>
   <div class="cu-form-group margin-top-xs text-xl" >
      <div class="title">{{info.applInfo||''}}</div>
   </div>
</div>
<div v-if="info.refundType==1" class="half-angle bg-white margin padding" style="text-align: left;">
   <div class="text-black text-bold  text-cut text-xl "><img  style="width: 18px;height: 18px;display: inline-block;margin-bottom: -3px;margin-right: 10px;" src="img/yes.png"/>本订单支持：<span style="font-weight: normal;">随时退  过期自动退</span></div>
</div>

<div class="s-modal" v-if="showShop">
  <div class="shop-modal">
    <div class="cu-bar bg-white" style="padding: 10px 20px;">
        <div class="action text-gray" @click="hideShop()" bindtap="hideModal">取消</div>
        <div class="action text-black text-bold text-xl" >请选择服务校区</div>
        <div class="action text-blue" @click="sureChange()">确定</div>
    </div>
    <div style="padding: 13px;overflow-y: auto; height: 86%;">
      <div v-for="(item, index) in shopList" :key="index" class="half-angle bg-white margin-top flex align-center justify-between padding-sm" >
        <div class="flex align-center ">
          <img class="shop-img" :src="item.shopLogo" />
          <div class="margin-left-sm">
              <div class=" text-bold text-left text-cut text-black " style="font-size: 18px; width: 400rpx;">{{item.shopName}}</div>
              <div class="text-left margin-tb-xs" style="font-size: 12px; color: #db0f0f;margin-top: 5px;"> 距你{{item.distance}}km</div>
              <div class="text-left text-cut " style=" font-size: 12px;color: #808080; width: 180px;margin-top: 5px">{{item.shopAddress}}{{item.shopDetailAddress}}</div>
          </div>
        </div>
        <div>
          <input type="radio" :checked="index == chooseIndex" @click="shopChange(index)"  class="red" value="" />
        </div>
      </div>
      <div style="width: 100%;height: 100px;"></div>
    </div>

  </div>
</div>


<!-- 
<van-picker title="请选择预约门店"  :class="dk?'picker-c':'picker-c2'" v-if="showShop" show-toolbar :columns="columns" @cancel="showShop = false" @confirm="onChange" /> -->
<van-datetime-picker type="date" title="预约时间（年月日）" :class="dk?'picker-c':'picker-c2'" :style="dk?'':'width: 42% !important;margin-left:29% !important'" :value="nowDate" v-if="showDate" @cancel="showDate = false"  @confirm="onTimeChange" />
<!-- <nut-datepicker
	:is-visible="isVisible"
	title="选择日期时间"
	type="datetime"
	:defaultValue="defaultValue"
	startDate="2022-01-01 00:08"
	endDate="2030-10-05 10:04"
	@close="switchPicker"
	@choose="setChooseValue"
></nut-datepicker> -->
<!-- <div class="half-angle bg-white margin padding" style="text-align: left;">
    <div class="flex" style=" display: flex;align-items:center;">
      <div class="text-black text-bold text-xl "><span class="text-bold text-red">*</span > 备&nbsp;&nbsp;&nbsp;&nbsp;注</div>
      <input v-model="notes" type="text" class="text-black text-xl margin-left-xl input1"   placeholder="请输入备注"/>
   </div>
</div> -->

<div v-if="introduceImg" class="half-angle bg-white margin padding" style="text-align: left;">
  <img style="width: 100%;" :src="introduceImg" />
</div>
<div style="height: 100px;"></div>
<!-- 购买按钮 -->
<div class="padding padding-bottom-xl flex align-center justify-between" style="position: fixed;bottom: 0;width: 100%;background-color: white; letter-spacing: 2px;" :style="!dk?'width: 42% !important;':''">
   <div class="text-red text-xxl text-bold text-bold">￥{{price/100}} <span class="oldp">￥{{oldPrice/100}}</span></div>
   <div class="an_shop2 text-bold" @click="payMoney()">确认支付</div>
</div>
<div v-if="showDd" class="toDd">
  <div @click="cloDd()" class="clo1">x</div>
  <div class="dd1" @click="goApp()">查看订单</div>
  <div @click="cloDd()" class="dd2">继续支付</div>
</div>
<div v-if="showDd" @click="cloDd()" class="zz"></div>
</div>
<!-- <img src="/img/buyright.jpg" :style="!dk?'width: 29%;position: fixed;right:0;top:0':''"/> -->
</div>
</template>
<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'buyYxAd',
  data () {
    return {
      requestHeadUrl: 'https://zhenqing.kequbang.com',
      // requestHeadUrl: 'http://localhost:8122',
      // requestHeadUrl22: 'http://localhost:8122',
      requestHeadUrl22: 'https://zhenqing.kequbang.com',
      // requestHeadUrl22: 'http://192.168.1.25:8122',
      isOpenVipModular: false,
      showModal: false, // 是否展示弹窗
      isVip: 0,
      storeId: '',
      userId: '',
      isMiniProgram: true,
      appLink: '',
      info: {},
      goodsAttributes: [],
      TabCur:0,
      modalName: '',
      goodsName: '',
      title: '',
      values: '',
      valueKey: '',
      price: '',
      oldPrice: '',
      userPhone: '',
      countdown: '',
      type:'',
      wxCode: '',
      showShop: false,
      chooseShop: '',
      showDate: false,
      nowDate:new Date(),
      chooseDate: '',
      col: '温州',
      columns: [],
      introduceImg: '',
      userName: '',
      notes: '',
      reservationShop: '',
      showDd: false,
      lat:'',
      lon:'',
      chooseIndex: null,
      checkIndex: null,
      shopList: []
    }
  },
  created () {
    const thisObj = this
    let params = this.$route.query;
    let userAgentInfo = navigator.userAgent;
    let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    let getArr = Agents.filter(i => userAgentInfo.includes(i));
    // true： 移动端 false： pc端
    thisObj.dk = getArr.length ? true : false;
    this.setTime()
    thisObj.goodsName = params.goodsName
    thisObj.price = params.price
    thisObj.oldPrice = params.oldPrice
    document.title = params.goodsName
    thisObj.type = params.type
    thisObj.valueKey = params.valueKey
    thisObj.wxCode = params.wxCode
    thisObj.getId = params.getId
    thisObj.introduceImg = params.introduceImg
    thisObj.lon = params.lon
    thisObj.lat = params.lat
    this.getInfos()
    thisObj.showDd = this.$root.showDd
    if (params.type==1) {
      return
    }
    thisObj.title = params.title
    thisObj.values = params.values
    // const thisObj = this
    // thisObj.onLoad()
  },
  methods: {
    onLoad: function () {
      // this.navigateToMiniProgram(JSON.stringify(payParam))
      var rr = window.location.href.split('/')
      //9d03442a91c345709dcbcd85daab9cc4
      var gid = rr[rr.length-1].split('-')[0]
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/p/goods/getByGoodId?goodId='+ gid +'&storeId=storezhenqing&linkId='+rr[rr.length-1], {}).then(res => {
        // console.log(res)
        res.goodsImgs = res.goodsImgs.split(",");
        res.goodsDetailImgs = res.goodsDetailImgs.split(",");
        thisObj.info = res 
        thisObj.goodsAttributes = JSON.parse(res.goodsAttributes)
        // console.log(thisObj.info)
        // console.log(thisObj.goodsAttributes)
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
      
      this.setTime()
    },
    getInfos() {
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/admin/goodsLink/getById?id='+ thisObj.getId +'&storeId=storezhenqing&linkId=', {}).then(res => {
        // console.log(res)
        res.goodsImgs = res.goodsImgs.split(",");
        res.goodsDetailImgs = res.goodsDetailImgs.split(",");
        thisObj.info = res 
        thisObj.goodsAttributes = JSON.parse(res.goodsAttributes)
        thisObj.titleName = res.goodsName
        thisObj.infoState = true
        // this.getLongitudeLatitude()
        this.getShops()
        // console.log(res.endTime.replace("-","/")+":00")
        this.swiperList = res.goodsImgs;
        console.log(this.swiperList)
        // console.log(thisObj.info)
        // console.log(thisObj.goodsAttributes)
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    getLongitudeLatitude() {
      var that = this
      //如果该对象存在，那么地理位置服务可用。
      if ('geolocation' in navigator) {
        /* 地理位置服务可用 */
        var options = {
          enableHighAccuracy: true, //布尔值，表示系统是否使用最高精度来表示结果，注意，这会导致较慢的响应时间或者增加电量消耗（比如对于支持gps的移动设备来说）。如果值为false ，设备会通过更快响应以及/或者使用更少的电量等方法来尽可能的节约资源。默认值fasle
          timeout: 5000, //它表明的是设备必须在多长时间（单位毫秒）内返回一个位置。默认直到获取到位置才会返回值。
          maximumAge: 0 //表明可以返回多长时间（即最长年龄，单位毫秒）内的可获取的缓存位置。如果设置为 0, 说明设备不能使用一个缓存位置，而且必须去获取一个真实的当前位置。默认0
        }
        function success(position) {
          
          //position.coords (只读) 返回一个定义了当前位置的Coordinates对象。
          //position.timestamp (只读) 返回一个时间戳DOMTimeStamp， 这个时间戳表示获取到的位置的时间。
          var lat = position.coords.latitude //当前位置的纬度
          var lon = position.coords.longitude //当前位置精度
          that.lat = lat
          that.lon = lon
          that.getShops()
          // alert(lat + "A233A" + lng)
        }
        function error(err) {
          console.log(err)
          var errorType = ['您拒绝共享位置信息', '获取不到位置信息', '获取位置信息超时']
          console.log(errorType[err.code - 1])
          // alert(errorType[err.code - 1])
          that.getShops()
        }
 
        navigator.geolocation.getCurrentPosition(success, error, options)
      } else {
        /* 地理位置服务不可用 */
        console.log('无法获取您的位置，请检查定位是否开启或刷新重试')
      }
    },
    getShops() {
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/group/shop/getAllShopsByGoods?lat='+ thisObj.lat +'&lon='+ thisObj.lon +'&goodsId='+thisObj.info.id, {}).then(res => {
        // console.log(res)
        thisObj.shopList = res
        var shopNames = []
        for (const i in res) {
          shopNames.push(res[i].shopName)
        }
        thisObj.columns = shopNames
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    // getShops() {
    //   const thisObj = this
    //   thisObj.$api.get(thisObj.requestHeadUrl + '/group/shop/getAllShopsByGoods?goodsId='+thisObj.info.id, {}).then(res => {
    //     // console.log(res)
    //     thisObj.shopList = res
    //     var shopNames = []
    //     for (const i in res) {
    //       shopNames.push(res[i].shopName)
    //     }
    //     thisObj.columns = shopNames
    //   }).catch(function (error) {
    //     thisObj.$util.requetServerError(error)
    //   })
    // },

    goApp() {
      location.href=this.appLink
    },
    cloDd () {
      this.$root.showDd = false
      this.showDd = false
    },
    tabSelect(e) {
      this.TabCur = e
    },
    // 页面跳转
    pageJump (uri, item) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    shopChange(index) {
      this.chooseIndex = index
    },
    sureChange () {
      console.log(this.chooseIndex)
      this.checkIndex = this.chooseIndex
      console.log(this.checkIndex)
      this.showShop = false
    },
    setTime() {
      var date = new Date() //1. js获取当前时间
      var min = date.getMinutes() //2. 获取当前分钟
      date.setMinutes(min + 10) //3. 设置当前时间+10分钟：把当前分钟数+10后的值重新设置为date对象的分钟数
      var y = date.getFullYear()
      var m = (date.getMonth() + 1) < 10 ? ("0" + (date.getMonth() + 1)) : (date.getMonth() + 1);
      var d = date.getDate() < 10 ? ("0" + date.getDate()) : date.getDate()
      var h = date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours()
      var f = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes();
      var s = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds()
      var formatdate = y + '-' + m + '-' + d + " " + h + ":" + f + ":" + s;
      console.log(formatdate)
      this.endDate2 = formatdate
      this.countTime()
    },
    countTime() {
      var that = this;
      var date = new Date();
      var now = date.getTime();
      var endDate = new Date(that.endDate2); //设置截止时间
      var end = endDate.getTime();
      var leftTime = end - now; //时间差
      var d, h, m, s, ms;
      if (leftTime >= 0) {
        d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        h = Math.floor(leftTime / 1000 / 60 / 60 % 24);
        m = Math.floor(leftTime / 1000 / 60 % 60);
        s = Math.floor(leftTime / 1000 % 60);
        ms = Math.floor(leftTime % 1000);
        ms = ms < 100 ? "0" + ms : ms
        s = s < 10 ? "0" + s : s
        m = m < 10 ? "0" + m : m
        h = h < 10 ? "0" + h : h
        that.countdown = m + ":" + s + "." + ms,
        //递归每秒调用countTime方法，显示动态时间效果
        setTimeout(that.countTime, 100);
      } else {
        console.log('已截止')
        that.countdown = '00:00:00'
      }
    },
    // 页面跳转
    pageJumpCate (uri) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    shopChooseShop() {
      this.showShop = true
    },
    hideShop() {
      this.chooseIndex = this.checkIndex
      this.showShop = false
    },
    onChange(e) {
      console.log(e)
      this.chooseShop = e
      this.showShop = false
    },
    shopChooseDate() {
      this.showDate = true
    },
    onTimeChange(date) {
      console.log(date)
      var y = date.getFullYear()
      var m = (date.getMonth() + 1) < 10 ? ("0" + (date.getMonth() + 1)) : (date.getMonth() + 1);
      var d = date.getDate() < 10 ? ("0" + date.getDate()) : date.getDate()
      var h = date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours()
      var f = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes();
      var formatdate = y + '-' + m + '-' + d + " " + h + ":" + f
      this.chooseDate = formatdate
      this.showDate = false
    },
    payMoney() {
      // location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd5ba93934e0b0e5b&redirect_uri=https://zxy.kequbang.com&response_type=code&scope=snsapi_base&state=111#wechat_redirect"
      if (this.userName.length == 0) {
        this.$util.requetServerError('亲,请输入姓名')
        return
      }
      var usernamezz = /^[\u4E00-\u9FA5]+$/;
      if (!usernamezz.test(this.userName)) {
        this.$util.requetServerError('亲,请正确填写使用人姓名')
        return false;
      }
      if (this.userPhone.length == 0) {
        this.$util.requetServerError('亲,请输入手机号码')
        return
      } else if (this.userPhone.length < 11) {
        this.$util.requetServerError('亲,你输入的手机号码长度少于11位')
        return
      }

      var that = this
      if(!that.dk) { // pc端支付
        that.commitPCPay()
        return
      }
      // return
      var wx = window.navigator.userAgent.toLowerCase();
      let params = this.$route.query;
      if (wx.match(/MicroMessenger/i) == 'micromessenger'){
        that.commitPay();
      } else if (wx.match(/MicroMessenger/i) != 'micromessenger' && that.dk) {
        that.commitH5Pay();
      }
      // alert(that.wxCode)
      return
      wx.config({
        debug: true, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印
        appId: 'wxd5ba93934e0b0e5b', // 必填，公众号的唯一标识
        timestamp: '1687510862', // 必填，生成签名的时间戳
        nonceStr: '1687510862473', // 必填，生成签名的随机串
        signature: '8E272500926E2C69BD4A67D89C80FF93',// 必填，签名
        jsApiList: ["checkJsApi", "chooseWXPay"], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp','chooseWXPay'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      });
      wx.chooseWXPay({
        timestamp: '1687510862', // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: '1687510862473', // 支付签名随机串，不长于 32 位
        package: "wx23170102348582e31e6da6b33f4ed10000", // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: "MD5", // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: "8E272500926E2C69BD4A67D89C80FF93", // 支付签名
        success: function (res) {
          // 支付成功后的回调函数
          // person.isVip = 1;
          // this.isVip = 1;
          // this.$root.userInfo = person;
          that.$util.showSuccessMsg("开通会员成功");
        },
        cancel: function () {
          alert("支付已取消");
        },
        error: function (e) {},
      });


    },

    commitPay () {
      var that = this
      var isLogin = that.$root.isLogin = true
      var wx = require('weixin-js-sdk')
      var href = window.location.href
      var urlConfig = that.requestHeadUrl + '/p/order'
      // var urlConfig = that.requestUrl + '/weixin/get/knowledge/config?fromDevice=h5'
      const thisObj = this
      thisObj.$api.post(thisObj.requestHeadUrl22 + '/p/order/get/js/config', {url: href}).then(res => {
        console.log(res)
        console.log(res.sign)
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.appid, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.noncestr, // 必填，生成签名的随机串
          signature: res.sign, // 必填，签名
          jsApiList: ['checkJsApi', 'chooseWXPay'] // 必填，需要使用的JS接口列表
        })
        
        wx.ready(res => {
          wx.checkJsApi({
            jsApiList: ['chooseWXPay'],
            success: res => {
              console.log('checked api:', res)
            },
            fail: err => {
              console.log('check api fail:', err)
            }
          })
        })
        // wx.ready(function(){

        //   console.log('ok')
        //   // config信息验证后会执行 ready 方法，所有接口调用都必须在 config 接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在 ready 函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在 ready 函数中。
        // });
        wx.error(function(res){
          // config信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的debug模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名。
          console.log("验证失败")
          console.log(res)
        });
        var postData = {
          code:that.wxCode,
          userName:that.userName,
          userPhone:that.userPhone,
          notes:that.notes,
          skuName:that.values,
          getId:that.getId,
          payType: 1,
          reservationShop: that.checkIndex?that.shopList[that.checkIndex].id:'',
          reservationShopName: that.checkIndex?that.shopList[that.checkIndex].shopName:'',
          reservationTime: that.chooseDate,
          qhclickid: thisObj.$root.qhclickid,
          sourceid: thisObj.$root.sourceid,
        }
        thisObj.$api.post(thisObj.requestHeadUrl22 + '/p/order/payYx', postData).then(result => {
          
          wx.chooseWXPay({
            timestamp: result.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: result.nonceStr, // 支付签名随机串，不长于 32 位
            package: result.packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: result.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: result.paySign, // 支付签名
            success: function (res) {
              // 支付成功后的回调函数
              that.$util.showSuccessMsg('支付成功')
              that.$api.get(thisObj.requestHeadUrl22 + '/p/order/openlink', {}).then(res2 => {
                // console.log(res)
                // if (res.resultCode === 200 && res.success) {
                  thisObj.appLink = res2.openlink 
                  location.href=res2.openlink 
                // } else {
                //   thisObj.$util.requetServerError(res.resultMsg)
                // }
              }).catch(function (error) {
                thisObj.$util.requetServerError(error)
              })


              
            },
            cancel: function () {
              alert('支付已取消')
            },
            error: function (e) {
              // alert(e)
            }
          })
        }).catch(function (error) {
          thisObj.$util.requetServerError(error)
        })

      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    commitH5Pay () {
      var that = this
      const thisObj = this
      that.$api.get(thisObj.requestHeadUrl22 + '/p/order/openlink', {}).then(res2 => {
                // console.log(res)
                // if (res.resultCode === 200 && res.success) {
              thisObj.appLink = res2.openlink 
            // } else {
            //   thisObj.$util.requetServerError(res.resultMsg)
            // }
          }).catch(function (error) {
            thisObj.$util.requetServerError(error)
          })
      var isLogin = that.$root.isLogin = true
      var wx = require('weixin-js-sdk')
      var href = window.location.href
      var urlConfig = that.requestHeadUrl + '/p/order'
      // var urlConfig = that.requestUrl + '/weixin/get/knowledge/config?fromDevice=h5'
        var postData = {
          code:that.wxCode,
          userName:that.userName,
          userPhone:that.userPhone,
          notes:that.notes,
          skuName:that.values,
          getId:that.getId,
          payType: 0,
          reservationShop: that.checkIndex?that.shopList[that.checkIndex].id:'',
          reservationShopName: that.checkIndex?that.shopList[that.checkIndex].shopName:'',
          reservationTime: that.chooseDate,
          qhclickid: thisObj.$root.qhclickid,
          sourceid: thisObj.$root.sourceid,
        }
        thisObj.$api.post(thisObj.requestHeadUrl22 + '/p/order/payYx', postData).then(result => {
          thisObj.showDd = true
          this.$root.showDd = true
          // console.log(result.mwebUrl)
          location.href=result.mwebUrl 
        }).catch(function (error) {
          thisObj.$util.requetServerError(error)
        })

    },
    commitPCPay () {
      var that = this
      var isLogin = that.$root.isLogin = true
      var wx = require('weixin-js-sdk')
      var href = window.location.href
      var urlConfig = that.requestHeadUrl + '/p/order'
      // var urlConfig = that.requestUrl + '/weixin/get/knowledge/config?fromDevice=h5'
      const thisObj = this
      var postData = {
        code:that.wxCode,
        userName:that.userName,
        userPhone:that.userPhone,
        notes:that.notes,
        skuName:that.values,
        getId:that.getId,
        payType: 2,
        reservationShop: that.checkIndex?that.shopList[that.checkIndex].id:'',
        reservationShopName: that.checkIndex?that.shopList[that.checkIndex].shopName:'',
        // reservationTime: that.chooseDate,
        qhclickid: thisObj.$root.qhclickid,
        sourceid: thisObj.$root.sourceid,
      }
      thisObj.$api.post(thisObj.requestHeadUrl22 + '/p/order/payYx', postData).then(result => {
        console.log(result)
        let queryData = {
        }
        console.log(result.codeUrl)
        thisObj.$root.codeUrl = result.codeUrl
        thisObj.$root.payPrice = thisObj.info.groupBuyingPrice
        thisObj.$router.push({
          path: '/payCode',
          query: queryData
        })
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
  }
}
</script>

<style>
.bg-e {
  background: #eeeeee;
}
.margin-top {
    margin-top: 30px;
}
.grid {
    display: flex;
    flex-wrap: wrap;
}
.justify-between {
    justify-content: space-between;
}
.align-center {
    align-items: center;
}
.text-xxl {
    font-size: 44px;
}
.margin {
    margin: 30px;
}
.half-angle {
    box-shadow: 1rpx 2rpx 18rpx 0rpx rgba(0, 0, 0, 0.12);
    border-radius: 40rpx;
}
.bg-white {
    background-color: var(--white);
    color: var(--darkGray);
}
.padding {
    padding: 30px;
}
.text-cut {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.text-xl2 {
    font-size: 33px;
}
.flex {
    display: flex;
}
.grid.col-2>div {
    width: 50%;
}
.text-orange, .line-orange, .lines-orange {
    color: #f37b1d;
}
.text-center {
    text-align: center;
}
.text-bold {
    font-weight: bold;
}
.text-xl {
    font-size: 36px;
}
.bg-white {
    background-color: #ffffff;
    color: #666666;
}
.padding {
    padding: 30px;
}
.padding-top {
    padding-top: 30px;
}
.b-b {
    border-bottom: 2px solid #CFCFCF;
}
.padding-sm {
    padding: 20px;
}
.flex-wrap {
    flex-wrap: wrap;
}
.flex {
    display: flex;
}
.text-bold {
    font-weight: bold;
}
.text-orange, .line-orange, .lines-orange {
    color: #f37b1d;
}

.on {
  font-size: 36px;
  border-radius: 20px 20px 0 0;
}

.shuxing {
  color: #ff6600;
  font-size: 29px;
  width: 29%;
  margin: 12px;
  border-radius: 20px;
  padding: 20px 8px;
  margin-top: 30px;
  background-color: #ffefe4;
  border: 2px solid #ff6600;
}
.an_shop2 {
  width: 40%;
  line-height: 80px;
  color: #fff;
  background-color: #ec3030;
  border-radius: 50px;
  text-align: center;
  font-size: 36px;
}
.half-angle {
    box-shadow: 1px 2px 18px 0px rgba(0, 0, 0, 0.12);
    border-radius: 40px;
}
.margin-top-sm {
    margin-top: 20px;
}
.margin-top-xs {
    margin-top: 13px;
}
.padding-top-sm {
    padding-top: 20px;
}
.padding-bottom-sm {
    padding-bottom: 20px;
}
.input1 {
  border: 0px !important;
  /* border-bottom: 1px solid #666666 !important; */
  text-align: center;
}
.oldp {
  text-decoration: line-through;
  color: #CFCFCF;
}
.text-red, .line-red, .lines-red {
    color: #e54d42;
}
.cu-form-group1 {
    background-color: #ffffff;
    display: flex;
    align-items: center;
    min-height: 30px;
    justify-content: space-between;
}
.cu-form-group {
    background-color: #ffffff;
    padding: 20px 30px;
    display: flex;
    align-items: center;
    min-height: 30px;
    justify-content: space-between;
}
.picker-c {
  position: fixed;
  width: 100%;
  z-index: 999;
  bottom: 0px;
  left: 0px;
}
.picker-c2 {
  position: fixed;
  min-width: 42% !important;
  z-index: 999;
  bottom: 0px;
  left: 0px;
}
.zz {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: black;
  z-index: 99;
  opacity: 0.3;
}
.toDd {
  position: fixed;
  z-index: 999;
  top: 35%;
  background: #ffffff;
  width: 80%;
  left: 10%;
  padding: 30px;
  font-size: 40px;
  color: #ffffff;
  border-radius: 15px;
}
.clo1 {
  color: black;
  position: absolute;
  right: -13px;
  top: -20px;
  font-size: 50pxs;
}
.dd1 {
  background: rgb(53, 116, 231);
  padding: 20px;
  margin: 40px 10px 30px 10px;
  border-radius: 10px;
}
.dd2 {
  background: rgb(53, 116, 231);
  padding: 20px;
  margin: 60px 10px 40px 10px;
  border-radius: 10px;
}
.s-modal {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9;
}
.shop-modal {
  position: absolute;
  width: 100%;
  height: 60%;
  z-index: 99;
  bottom: 0px;
  left: 0px;
  background-color: #f8f8f8;;
}
.cu-bar {
    display: flex;
    position: relative;
    align-items: center;
    min-height: 100rpx;
    justify-content: space-between;
}
.action {
    min-width: 50px;
    margin-right: 0;
    min-height: 50px;
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: center;
    max-width: 100%;
}
.text-blue {
  color: #0081ff;
}
.text-cut {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.text-left {
    text-align: left;
}
</style>
